import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const WeBuySurplusValvesPage: React.FC = () => {
  useEffect(() => {
    // Set document title and meta tags using React 19 features
    document.title = 'We Buy Surplus Valves | Top Cash Prices for Industrial Valves Nationwide';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'We Buy Surplus Valves across 9 states. Get top dollar for your surplus control valves, safety valves, ball valves, and gate valves. Fast quotes, free pickup, competitive pricing. Call today for immediate evaluation.');
    }

    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'we buy surplus valves, surplus valve buyers, sell surplus valves, industrial valve buyers, control valve buyers, safety valve buyers');
    }

    // Add comprehensive schema markup
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://yoursite.com/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "We Buy Surplus Valves",
              "item": "https://yoursite.com/we-buy-surplus-valves"
            }
          ]
        },
        {
          "@type": "Service",
          "name": "We Buy Surplus Valves - Industrial Valve Buyers",
          "description": "Professional surplus valve buying services across 9 states. We purchase Fisher valves, Rosemount transmitters, safety relief valves, pipeline valves, control valves, and all major brands of industrial equipment from refineries, chemical plants, and oil & gas facilities.",
          "provider": {
            "@type": "Organization",
            "name": "ValveSalesSupply",
            "telephone": "+1-214-854-5638",
            "url": "https://yoursite.com"
          },
          "areaServed": [
            {
              "@type": "State",
              "name": "Texas",
              "url": "https://yoursite.com/texas"
            },
            {
              "@type": "State",
              "name": "Oklahoma",
              "url": "https://yoursite.com/oklahoma"
            },
            {
              "@type": "State",
              "name": "Louisiana",
              "url": "https://yoursite.com/louisiana"
            },
            {
              "@type": "State",
              "name": "New Mexico",
              "url": "https://yoursite.com/new-mexico"
            },
            {
              "@type": "State",
              "name": "Kansas",
              "url": "https://yoursite.com/kansas"
            },
            {
              "@type": "State",
              "name": "North Dakota",
              "url": "https://yoursite.com/north-dakota"
            },
            {
              "@type": "State",
              "name": "South Dakota",
              "url": "https://yoursite.com/south-dakota"
            },
            {
              "@type": "State",
              "name": "Utah",
              "url": "https://yoursite.com/utah"
            },
            {
              "@type": "State",
              "name": "Wyoming",
              "url": "https://yoursite.com/wyoming"
            }
          ],
          "serviceType": "Industrial Equipment Purchasing",
          "offers": {
            "@type": "Offer",
            "description": "Competitive cash offers for surplus industrial valves and equipment",
            "availability": "https://schema.org/InStock"
          }
        },
        {
          "@type": "Product",
          "name": "Fisher Control Valves - Surplus Valve Buyers",
          "description": "We buy surplus Fisher control valves including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, and all Fisher valve models. Top cash prices paid for used Fisher valves from refineries and chemical plants.",
          "brand": {
            "@type": "Brand",
            "name": "Fisher"
          },
          "category": "Control Valves",
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Fisher control valves - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Industrial Equipment Manager"
            },
            "reviewBody": "Excellent service buying our surplus Fisher control valves. Fast response, fair pricing, and professional pickup service."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "127",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Rosemount Transmitters - Surplus Equipment Buyers",
          "description": "We buy surplus Rosemount transmitters including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, and all Rosemount instrumentation. Immediate cash offers for used Rosemount equipment.",
          "brand": {
            "@type": "Brand",
            "name": "Rosemount"
          },
          "category": "Transmitters & Instrumentation",
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Rosemount transmitters - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Refinery Maintenance Supervisor"
            },
            "reviewBody": "Outstanding experience selling our surplus Rosemount transmitters. Quick evaluation and competitive pricing on all instrumentation."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "94",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Safety Relief Valves - Surplus Valve Buyers",
          "description": "We buy surplus safety relief valves from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser. Top dollar paid for pressure relief valves, safety valves, and overpressure protection equipment.",
          "brand": [
            {
              "@type": "Brand",
              "name": "Crosby"
            },
            {
              "@type": "Brand",
              "name": "Anderson Greenwood"
            },
            {
              "@type": "Brand",
              "name": "Consolidated"
            }
          ],
          "category": "Safety Relief Valves",
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy safety relief valves - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Plant Operations Director"
            },
            "reviewBody": "Professional service purchasing our surplus safety relief valves. They understood the critical nature of these components and paid accordingly."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "156",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Pipeline Valves - Surplus Valve Buyers",
          "description": "We buy surplus pipeline valves including ball valves, gate valves, check valves, and plug valves from Cameron, Velan, Powell, WKM, Grove, and all major manufacturers. Cash paid for pipeline isolation valves.",
          "brand": [
            {
              "@type": "Brand",
              "name": "Cameron"
            },
            {
              "@type": "Brand",
              "name": "Velan"
            },
            {
              "@type": "Brand",
              "name": "WKM"
            }
          ],
          "category": "Pipeline Valves",
          "offers": {
            "@type": "Offer",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy pipeline valves - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Pipeline Operations Manager"
            },
            "reviewBody": "Excellent experience selling our surplus pipeline valves. Fair market pricing and efficient logistics coordination for large valve quantities."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "183",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Houston",
          "description": "We buy surplus valves in Houston, Texas serving refineries and petrochemical facilities",
          "url": "https://yoursite.com/houston",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Houston",
            "addressRegion": "TX",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Dallas",
          "description": "We buy surplus valves in Dallas, Texas serving manufacturing and industrial facilities",
          "url": "https://yoursite.com/dallas",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Dallas",
            "addressRegion": "TX",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Oklahoma City",
          "description": "We buy surplus valves in Oklahoma City serving oil and gas operations",
          "url": "https://yoursite.com/oklahoma-city",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Oklahoma City",
            "addressRegion": "OK",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Tulsa",
          "description": "We buy surplus valves in Tulsa, Oklahoma serving refineries and pipeline operations",
          "url": "https://yoursite.com/tulsa",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Tulsa",
            "addressRegion": "OK",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Baton Rouge",
          "description": "We buy surplus valves in Baton Rouge, Louisiana serving Gulf Coast refineries",
          "url": "https://yoursite.com/baton-rouge",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Baton Rouge",
            "addressRegion": "LA",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Lake Charles",
          "description": "We buy surplus valves in Lake Charles, Louisiana serving petrochemical plants",
          "url": "https://yoursite.com/lake-charles",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Lake Charles",
            "addressRegion": "LA",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Albuquerque",
          "description": "We buy surplus valves in Albuquerque, New Mexico serving industrial facilities",
          "url": "https://yoursite.com/albuquerque",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Albuquerque",
            "addressRegion": "NM",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Roswell",
          "description": "We buy surplus valves in Roswell, New Mexico serving Permian Basin operations",
          "url": "https://yoursite.com/roswell",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Roswell",
            "addressRegion": "NM",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Hobbs",
          "description": "We buy surplus valves in Hobbs, New Mexico serving oil and gas facilities",
          "url": "https://yoursite.com/hobbs",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Hobbs",
            "addressRegion": "NM",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Artesia",
          "description": "We buy surplus valves in Artesia, New Mexico serving refineries and gas plants",
          "url": "https://yoursite.com/artesia",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Artesia",
            "addressRegion": "NM",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Wichita",
          "description": "We buy surplus valves in Wichita, Kansas serving manufacturing and refining",
          "url": "https://yoursite.com/wichita",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Wichita",
            "addressRegion": "KS",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Bismarck",
          "description": "We buy surplus valves in Bismarck, North Dakota serving energy facilities",
          "url": "https://yoursite.com/bismarck",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Bismarck",
            "addressRegion": "ND",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Williston",
          "description": "We buy surplus valves in Williston, North Dakota serving Bakken oil field",
          "url": "https://yoursite.com/williston",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Williston",
            "addressRegion": "ND",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Sioux Falls",
          "description": "We buy surplus valves in Sioux Falls, South Dakota serving industrial facilities",
          "url": "https://yoursite.com/sioux-falls",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Sioux Falls",
            "addressRegion": "SD",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Rapid City",
          "description": "We buy surplus valves in Rapid City, South Dakota serving mining operations",
          "url": "https://yoursite.com/rapid-city",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Rapid City",
            "addressRegion": "SD",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Salt Lake City",
          "description": "We buy surplus valves in Salt Lake City, Utah serving mining and chemical plants",
          "url": "https://yoursite.com/salt-lake-city",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Salt Lake City",
            "addressRegion": "UT",
            "addressCountry": "US"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "Surplus Valve Buyers in Cheyenne",
          "description": "We buy surplus valves in Cheyenne, Wyoming serving energy facilities",
          "url": "https://yoursite.com/cheyenne",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Cheyenne",
            "addressRegion": "WY",
            "addressCountry": "US"
          }
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of surplus valves do you buy?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all types of surplus valves including Fisher control valves, safety relief valves from Crosby and Anderson Greenwood, pipeline valves from Cameron and Velan, ball valves, gate valves, check valves, butterfly valves, and plug valves. We purchase valves from all major manufacturers including Masoneilan, Flowserve, WKM, Grove, and many others."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Rosemount transmitters and instrumentation?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we buy Rosemount transmitters including Rosemount 3051, 2088, 644, 8800 models and all Rosemount instrumentation. We also purchase transmitters from other manufacturers, pressure gauges, flow meters, analyzers, and complete instrumentation packages from refineries and chemical plants."
              }
            },
            {
              "@type": "Question",
              "name": "Which states do you buy surplus valves in?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy surplus valves across 9 states: Texas, Oklahoma, Louisiana, New Mexico, Kansas, North Dakota, South Dakota, Utah, and Wyoming. We serve major cities including Houston, Dallas, Oklahoma City, Tulsa, Baton Rouge, Albuquerque, Wichita, and many others throughout these regions."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Fisher valves specifically?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we are major buyers of Fisher valves including all Fisher control valve models such as Fisher EZ, ED, HP, DVC6000, and Fisher regulators. Fisher valves are in high demand and we pay top dollar for surplus Fisher equipment in any condition."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you provide a quote for surplus valves?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide quotes within 24-48 hours for most surplus valve inventories. For urgent situations, we offer same-day response if you contact us before 3PM. Simply call us at (214) 854-5638 or send photos and details of your surplus valves for immediate evaluation."
              }
            },
            {
              "@type": "Question",
              "name": "Do you offer free pickup for surplus valves?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we provide free pickup service for surplus valves across all 9 states we serve. Our professional logistics team coordinates pickup schedules that work with your operations, handles all transportation, and provides immediate payment upon pickup completion."
              }
            }
          ]
        },
        {
          "@type": "WebPage",
          "name": "We Buy Surplus Valves - Fisher Valves, Rosemount, Safety Relief Valves, Pipeline Valves",
          "description": "Professional surplus valve buyers across Texas, Oklahoma, Louisiana, New Mexico, Kansas, North Dakota, South Dakota, Utah, and Wyoming. We buy Fisher control valves, Rosemount transmitters, safety relief valves, pipeline valves, and all industrial equipment. Same-day quotes, free pickup, competitive cash offers.",
          "url": "https://yoursite.com/we-buy-surplus-valves",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://yoursite.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "We Buy Surplus Valves",
                "item": "https://yoursite.com/we-buy-surplus-valves"
              }
            ]
          }
        }
      ]
    });
    document.head.appendChild(schemaScript);

    return () => {
      if (schemaScript.parentNode) {
        schemaScript.parentNode.removeChild(schemaScript);
      }
    };
  }, []);

  const stateLocations = [
    {
      state: 'Texas',
      link: '/texas',
      cities: ['Houston', 'Dallas', 'Beaumont', 'Corpus Christi', 'Austin', 'San Antonio', 'El Paso'],
      valveCount: '8,500+',
      responseTime: '24hr',
      specialties: 'Refinery operations, petrochemical facilities, offshore platforms'
    },
    {
      state: 'Oklahoma',
      link: '/oklahoma',
      cities: ['Oklahoma City', 'Tulsa'],
      valveCount: '2,100+',
      responseTime: '48hr',
      specialties: 'Oil & gas production, pipeline systems, drilling operations'
    },
    {
      state: 'Louisiana',
      link: '/louisiana',
      cities: ['Baton Rouge', 'Lake Charles'],
      valveCount: '3,200+',
      responseTime: '36hr',
      specialties: 'Gulf Coast refineries, chemical plants, marine terminals'
    },
    {
      state: 'New Mexico',
      link: '/new-mexico',
      cities: ['Albuquerque', 'Roswell', 'Hobbs', 'Artesia'],
      valveCount: '1,800+',
      responseTime: '48hr',
      specialties: 'Permian Basin operations, desert facilities, natural gas processing'
    },
    {
      state: 'North Dakota',
      link: '/north-dakota',
      cities: ['Bismarck', 'Williston'],
      valveCount: '1,400+',
      responseTime: '72hr',
      specialties: 'Bakken shale operations, cold weather systems, fracking equipment'
    },
    {
      state: 'South Dakota',
      link: '/south-dakota',
      cities: ['Rapid City', 'Sioux Falls'],
      valveCount: '800+',
      responseTime: '72hr',
      specialties: 'Pipeline infrastructure, agricultural processing, mining operations'
    },
    {
      state: 'Kansas',
      link: '/kansas',
      cities: ['Wichita', 'Topeka', 'Kansas City'],
      valveCount: '1,200+',
      responseTime: '48hr',
      specialties: 'Oil refineries, agricultural facilities, manufacturing plants'
    },
    {
      state: 'Utah',
      link: '/utah',
      cities: ['Salt Lake City', 'Provo'],
      valveCount: '900+',
      responseTime: '72hr',
      specialties: 'Mining operations, chemical processing, mountain facility access'
    },
    {
      state: 'Wyoming',
      link: '/wyoming',
      cities: ['Cheyenne', 'Casper'],
      valveCount: '700+',
      responseTime: '72hr',
      specialties: 'Natural gas production, coal operations, remote facility servicing'
    }
  ];

  const valveTypes = [
    {
      category: 'Control Valves',
      brands: ['Fisher', 'Masoneilan', 'Valtek', 'Flowserve', 'Samson', 'Metso', 'Emerson'],
      description: 'Precision control valves for flow, pressure, and temperature regulation in critical processes.'
    },
    {
      category: 'Safety & Relief Valves',
      brands: ['Crosby', 'Anderson Greenwood', 'Consolidated', 'Leser', 'Farris', 'Dresser'],
      description: 'Critical safety equipment protecting vessels and pipelines from overpressure conditions.'
    },
    {
      category: 'Ball & Gate Valves',
      brands: ['Cameron', 'Velan', 'Powell', 'WKM', 'FMC', 'Grove', 'Daniel'],
      description: 'Heavy-duty isolation valves for upstream, midstream, and downstream applications.'
    },
    {
      category: 'Check Valves',
      brands: ['Wheatley', 'Mission', 'Hobbs', 'McDonald', 'API', 'Fluid Control'],
      description: 'Preventing backflow and protecting equipment in pipeline and processing systems.'
    },
    {
      category: 'Butterfly Valves',
      brands: ['Keystone', 'Jamesbury', 'Bray', 'Dezurik', 'Henry Pratt', 'Crane'],
      description: 'Versatile quarter-turn valves for large diameter applications and tight shutoff.'
    },
    {
      category: 'Plug Valves',
      brands: ['Nordstrom', 'Xomox', 'Hills McCanna', 'Cooper Cameron', 'Homestead'],
      description: 'Reliable quarter-turn valves for severe service and slurry applications.'
    }
  ];

  return (
    <>
      <Header />
      
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen pt-20">
        {/* Breadcrumbs */}
        <nav className="bg-white border-b border-gray-200" aria-label="Breadcrumb">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <ol className="flex items-center space-x-2 text-sm">
              <li>
                <Link to="/" className="text-teal-600 hover:text-teal-700 font-medium">
                  Home
                </Link>
              </li>
              <li className="flex items-center">
                <i className="ri-arrow-right-s-line text-gray-400 mx-2"></i>
                <span className="text-gray-900 font-semibold">We Buy Surplus Valves</span>
              </li>
            </ol>
          </div>
        </nav>

        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center">
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: `url('https://public.readdy.ai/ai/img_res/024f8736d86f05dab9b773c4bd639980.jpg')`
            }}
            role="img"
            aria-label="Field of surplus valves on pallets in refinery facility - ValveSalesSupply valve purchasing services"
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
          </div>
          
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full py-12">
            <div className="max-w-2xl">
              <div className="bg-red-600 text-white px-4 py-2 rounded-full inline-block mb-4 animate-pulse">
                <i className="ri-fire-line mr-2"></i>
                PAYING HIGHEST PRICE IN THE INDUSTRY
              </div>
              <p className="text-white/80 uppercase text-xs sm:text-sm font-semibold mb-3 sm:mb-4 tracking-[2px]">
                URGENT: PLANT TURNAROUNDS STARTING - WE NEED YOUR SURPLUS
              </p>
              <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 sm:mb-6">
                We Buy Surplus Valves
              </h1>
              <div className="bg-yellow-400 text-black p-4 rounded-lg mb-6 font-bold">
                <div className="text-lg mb-2">⚡ SAME-DAY CASH OFFERS ⚡</div>
                <div className="text-sm">Call before 3PM - Get quote same day, pickup tomorrow</div>
              </div>
              <div className="text-gray-200 text-sm sm:text-base md:text-lg lg:text-xl mb-6 sm:mb-10 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0 sm:space-x-4">
                <span>✓ All Major Brands</span>
                <span className="hidden sm:block w-2 h-2 bg-white rounded-full"></span>
                <span>✓ Free Pickup & Documentation</span>
                <span className="hidden sm:block w-2 h-2 bg-white rounded-full"></span>
                <span>✓ Cash Payment On Pickup</span>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">
                <a
                  href="tel:214-854-5638"
                  className="bg-red-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-2xl font-bold text-base sm:text-lg hover:bg-red-700 transition-all duration-300 flex items-center justify-center whitespace-nowrap animate-bounce"
                >
                  <i className="ri-phone-line mr-2"></i>
                  CALL NOW: (214) 854-5638
                </a>
                <Link
                  to="/contact"
                  className="border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-2xl font-semibold text-base sm:text-lg hover:bg-white hover:text-black transition-all duration-300 flex items-center justify-center whitespace-nowrap"
                >
                  TEXT PHOTOS FOR INSTANT QUOTE
                  <i className="ri-arrow-right-line ml-2"></i>
                </Link>
              </div>

              <div className="mt-8 bg-white/10 backdrop-blur-sm rounded-lg p-4">
                <div className="text-white text-sm mb-2">🔥 HOT DEMAND RIGHT NOW:</div>
                <div className="grid grid-cols-2 gap-2 text-xs text-white/90">
                  <div>• Fisher Control Valves</div>
                  <div>• Safety Relief Valves</div>
                  <div>• Ball & Gate Valves</div>
                  <div>• All Major Brands</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <div className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Why We Buy Surplus Valves from Equipment Sellers Nationwide
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                With decades of experience in the industrial equipment market, we provide 
                unmatched expertise and service when we buy surplus valves from refineries, chemical plants, and industrial facilities across America.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
              <div className="bg-gray-50 p-8 rounded-xl">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-money-dollar-circle-line text-3xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Competitive Pricing</h3>
                <p className="text-gray-600 leading-relaxed">
                  Our extensive network and market knowledge ensure you receive top dollar when we buy surplus valves from your facility. We evaluate each piece based on current market conditions and future demand.
                </p>
              </div>

              <div className="bg-gray-50 p-8 rounded-xl">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-truck-line text-3xl text-orange-600"></i>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Free Pickup Service</h3>
                <p className="text-gray-600 leading-relaxed">
                  Our professional logistics team handles all transportation at no cost to you. 
                  We coordinate pickup schedules that work with your operations and timeline.
                </p>
              </div>

              <div className="bg-gray-50 p-8 rounded-xl">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-time-line text-3xl text-blue-600"></i>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Rapid Response</h3>
                <p className="text-gray-600 leading-relaxed">
                  Quick evaluations and fast decision-making. Most quotes provided within 24-48 hours, 
                  with same-day response available for urgent situations.
                </p>
              </div>

              <div className="bg-gray-50 p-8 rounded-xl">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-3xl text-purple-600"></i>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Proper Documentation</h3>
                <p className="text-gray-600 leading-relaxed">
                  Complete paperwork handling including material certificates, test reports, 
                  and all necessary documentation for regulatory compliance and audit trails.
                </p>
              </div>

              <div className="bg-gray-50 p-8 rounded-xl">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-tools-line text-3xl text-red-600"></i>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Expert Evaluation</h3>
                <p className="text-gray-600 leading-relaxed">
                  Our certified technicians perform thorough inspections to determine fair market value. 
                  We understand valve specifications, conditions, and applications across all industries.
                </p>
              </div>

              <div className="bg-gray-50 p-8 rounded-xl">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-recycle-line text-3xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Environmental Responsibility</h3>
                <p className="text-gray-600 leading-relaxed">
                  We ensure proper handling and disposal of all materials, following environmental 
                  regulations and promoting sustainable practices in equipment lifecycle management.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Valve Types Section */}
        <div className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Types of Surplus Valves We Purchase
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                We buy surplus valves of all major types from leading manufacturers, regardless of condition. 
                Our expertise spans the entire spectrum of industrial valve applications.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
              {valveTypes.map((valve, index) => (
                <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden">
                  <div className="p-8">
                    <h3 className="text-2xl font-semibold text-gray-900 mb-4">{valve.category}</h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">{valve.description}</p>
                    <div className="space-y-2">
                      <h4 className="text-lg font-medium text-gray-900">Leading Brands:</h4>
                      <div className="flex flex-wrap gap-2">
                        {valve.brands.map((brand, brandIndex) => (
                          <span
                            key={brandIndex}
                            className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium"
                          >
                            {brand}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Service Areas Section */}
        <div className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Where We Buy Surplus Valves - Service Areas
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                We buy surplus valves across the central United States, 
                with specialized expertise in each region's industrial sectors and immediate response capabilities.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {stateLocations.map((location, index) => (
                <Link
                  key={index}
                  to={location.link}
                  className="group bg-white border border-gray-200 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden"
                >
                  <div className="p-8">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-2xl font-bold text-gray-900 group-hover:text-green-600 transition-colors">
                        {location.state}
                      </h3>
                      <i className="ri-arrow-right-line text-2xl text-gray-400 group-hover:text-green-600 transition-colors"></i>
                    </div>
                    
                    <div className="space-y-3 mb-6">
                      <div className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                        <span className="text-gray-700"><strong>{location.valveCount}</strong> valves purchased</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                        <span className="text-gray-700"><strong>{location.responseTime}</strong> average response</span>
                      </div>
                    </div>

                    <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                      <strong>Specialties:</strong> {location.specialties}
                    </p>

                    <div className="mb-4">
                      <h4 className="text-sm font-semibold text-gray-900 mb-2">Major Cities Served:</h4>
                      <div className="flex flex-wrap gap-1">
                        {location.cities.map((city, cityIndex) => (
                          <span
                            key={cityIndex}
                            className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-xs"
                          >
                            {city}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div className="text-green-600 text-sm font-medium group-hover:text-green-700 transition-colors">
                      View {location.state} Details →
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Process Section */}
        <div className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Our Simple 4-Step Process When We Buy Surplus Valves
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Selling your surplus valves has never been easier. From initial contact to final payment, 
                we handle everything professionally and efficiently.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl font-bold text-green-600">1</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Contact Us</h3>
                <p className="text-gray-600 leading-relaxed">
                  Call, email, or fill out our online form with details about your surplus valve inventory. 
                  Include quantities, brands, and photos if available.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl font-bold text-orange-600">2</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Evaluation</h3>
                <p className="text-gray-600 leading-relaxed">
                  Our experts review your inventory and provide a comprehensive evaluation. 
                  We may schedule an on-site inspection for large quantities.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl font-bold text-blue-600">3</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Offer & Agreement</h3>
                <p className="text-gray-600 leading-relaxed">
                  Receive a competitive cash offer within 24-48 hours. Once accepted, 
                  we prepare all necessary documentation and agreements.
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <span className="text-3xl font-bold text-purple-600">4</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Pickup & Payment</h3>
                <p className="text-gray-600 leading-relaxed">
                  We coordinate free pickup at your convenience and provide immediate payment 
                  upon completion of the transaction.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="py-20 bg-gradient-to-r from-green-600 to-green-500 text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ready to Sell? We Buy Surplus Valves Today!
            </h2>
            <p className="text-xl mb-8 leading-relaxed">
              Get started today with a free evaluation. Our team is standing by to provide 
              you with a competitive offer. We buy surplus valves of all types, brands, and conditions nationwide.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="bg-white text-green-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap"
              >
                Get Free Quote Today
              </Link>
              <a
                href="tel:214-854-5638"
                className="bg-green-700 hover:bg-green-800 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap"
              >
                Call (214) 854-5638
              </a>
            </div>
          </div>
        </div>

        {/* States Section */}
        <div className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Surplus Valve Buyers by State
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                We buy surplus valves across 9 states in the central United States. Click on your state to learn more about our services in your area.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              <Link
                to="/texas"
                className="group bg-gradient-to-br from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 p-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Texas
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Leading surplus valve buyers serving Houston, Dallas, Austin, and all major Texas refineries and petrochemical facilities. We buy control valves, safety valves, and industrial equipment statewide.
                </p>
                <div className="text-teal-600 font-semibold group-hover:text-teal-700 flex items-center">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>

              <Link
                to="/oklahoma"
                className="group bg-gradient-to-br from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 p-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Oklahoma
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Trusted surplus valve buyers in Oklahoma City, Tulsa, and throughout Oklahoma's oil and gas regions. We purchase surplus valves from drilling operations, refineries, and pipeline facilities.
                </p>
                <div className="text-teal-600 font-semibold group-hover:text-teal-700 flex items-center">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>

              <Link
                to="/louisiana"
                className="group bg-gradient-to-br from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 p-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Louisiana
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Professional surplus valve buyers serving Baton Rouge, Lake Charles, and Louisiana's Gulf Coast refineries. We buy surplus control valves, safety valves, and process equipment from chemical plants.
                </p>
                <div className="text-teal-600 font-semibold group-hover:text-teal-700 flex items-center">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>

              <Link
                to="/new-mexico"
                className="group bg-gradient-to-br from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 p-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in New Mexico
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Experienced surplus valve buyers in Albuquerque, Roswell, Hobbs, and Artesia. We purchase surplus valves from Permian Basin operations and natural gas processing facilities throughout New Mexico.
                </p>
                <div className="text-teal-600 font-semibold group-hover:text-teal-700 flex items-center">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>

              <Link
                to="/kansas"
                className="group bg-gradient-to-br from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 p-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Kansas
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Reliable surplus valve buyers serving Wichita, Kansas City, Topeka, and Kansas refineries. We buy surplus industrial valves from oil refineries, agricultural facilities, and manufacturing plants.
                </p>
                <div className="text-teal-600 font-semibold group-hover:text-teal-700 flex items-center">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>

              <Link
                to="/north-dakota"
                className="group bg-gradient-to-br from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 p-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in North Dakota
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Specialized surplus valve buyers in Bismarck, Williston, and North Dakota's Bakken region. We purchase surplus valves from shale operations, fracking equipment, and cold weather industrial systems.
                </p>
                <div className="text-teal-600 font-semibold group-hover:text-teal-700 flex items-center">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>

              <Link
                to="/south-dakota"
                className="group bg-gradient-to-br from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 p-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in South Dakota
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Professional surplus valve buyers serving Sioux Falls, Rapid City, and South Dakota's industrial facilities. We buy surplus valves from pipeline infrastructure, agricultural processing, and mining operations.
                </p>
                <div className="text-teal-600 font-semibold group-hover:text-teal-700 flex items-center">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>

              <Link
                to="/utah"
                className="group bg-gradient-to-br from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 p-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Utah
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Expert surplus valve buyers in Salt Lake City, Provo, and Utah's mining regions. We purchase surplus valves from mining operations, chemical processing facilities, and mountain industrial sites.
                </p>
                <div className="text-teal-600 font-semibold group-hover:text-teal-700 flex items-center">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>

              <Link
                to="/wyoming"
                className="group bg-gradient-to-br from-teal-50 to-teal-100 hover:from-teal-100 hover:to-teal-200 p-8 rounded-xl transition-all duration-300 shadow-md hover:shadow-xl"
              >
                <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Wyoming
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Dedicated surplus valve buyers serving Cheyenne, Casper, and Wyoming's energy sector. We buy surplus valves from natural gas production, coal operations, and remote industrial facilities statewide.
                </p>
                <div className="text-teal-600 font-semibold group-hover:text-teal-700 flex items-center">
                  Learn More <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </Link>
            </div>
          </div>
        </div>

        {/* Cities Section */}
        <div className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Surplus Valve Buyers in:
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                We buy surplus valves in major cities across the central United States. Find your city below to learn about our local valve buying services.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              <Link
                to="/houston"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Houston
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Leading surplus valve buyers serving Houston's massive refinery and petrochemical complex with same-day response and competitive pricing.
                </p>
              </Link>

              <Link
                to="/dallas"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Dallas
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Professional surplus valve buyers in Dallas serving manufacturing facilities and industrial operations throughout the DFW metroplex.
                </p>
              </Link>

              <Link
                to="/austin"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Austin
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Trusted surplus valve buyers in Austin purchasing from technology manufacturing and semiconductor facilities in Central Texas.
                </p>
              </Link>

              <Link
                to="/san-antonio"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in San Antonio
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Experienced surplus valve buyers serving San Antonio's Eagle Ford shale operations and South Texas industrial facilities.
                </p>
              </Link>

              <Link
                to="/corpus-christi"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Corpus Christi
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Specialized surplus valve buyers in Corpus Christi serving Gulf Coast refineries and offshore platform equipment suppliers.
                </p>
              </Link>

              <Link
                to="/el-paso"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in El Paso
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Reliable surplus valve buyers in El Paso purchasing from Permian Basin operations and West Texas industrial facilities.
                </p>
              </Link>

              <Link
                to="/beaumont"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Beaumont
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Expert surplus valve buyers serving Beaumont's Golden Triangle refineries and Southeast Texas petrochemical plants.
                </p>
              </Link>

              <Link
                to="/oklahoma-city"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Oklahoma City
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Professional surplus valve buyers in Oklahoma City serving oil and gas operations throughout central Oklahoma.
                </p>
              </Link>

              <Link
                to="/tulsa"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Tulsa
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Experienced surplus valve buyers in Tulsa purchasing from refineries and pipeline operations in northeast Oklahoma.
                </p>
              </Link>

              <Link
                to="/baton-rouge"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Baton Rouge
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Leading surplus valve buyers serving Baton Rouge's major refineries and chemical plants along the Mississippi River.
                </p>
              </Link>

              <Link
                to="/lake-charles"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Lake Charles
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Trusted surplus valve buyers in Lake Charles purchasing from Southwest Louisiana's petrochemical corridor facilities.
                </p>
              </Link>

              <Link
                to="/albuquerque"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Albuquerque
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Professional surplus valve buyers serving Albuquerque's technology and manufacturing facilities throughout New Mexico.
                </p>
              </Link>

              <Link
                to="/roswell"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Roswell
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Experienced surplus valve buyers in Roswell serving Permian Basin oil and gas operations in southeast New Mexico.
                </p>
              </Link>

              <Link
                to="/hobbs"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Hobbs
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Specialized surplus valve buyers in Hobbs purchasing from Permian Basin drilling and production facilities.
                </p>
              </Link>

              <Link
                to="/artesia"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Artesia
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Reliable surplus valve buyers serving Artesia's oil refineries and natural gas processing plants in New Mexico.
                </p>
              </Link>

              <Link
                to="/wichita"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Wichita
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Expert surplus valve buyers in Wichita serving aircraft manufacturing and oil refining operations throughout Kansas.
                </p>
              </Link>

              <Link
                to="/kansas-city"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Kansas City
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Professional surplus valve buyers serving Kansas City's manufacturing facilities and industrial operations.
                </p>
              </Link>

              <Link
                to="/topeka"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Topeka
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Trusted surplus valve buyers in Topeka purchasing from agricultural processing and manufacturing facilities in Kansas.
                </p>
              </Link>

              <Link
                to="/bismarck"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Bismarck
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Experienced surplus valve buyers serving Bismarck's energy facilities and North Dakota's capital region operations.
                </p>
              </Link>

              <Link
                to="/williston"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Williston
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Specialized surplus valve buyers in Williston serving Bakken oil field operations and fracking equipment suppliers.
                </p>
              </Link>

              <Link
                to="/sioux-falls"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Sioux Falls
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Professional surplus valve buyers serving Sioux Falls' ethanol production and food processing facilities in South Dakota.
                </p>
              </Link>

              <Link
                to="/rapid-city"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Rapid City
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Reliable surplus valve buyers in Rapid City purchasing from mining operations and Black Hills industrial facilities.
                </p>
              </Link>

              <Link
                to="/cheyenne"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Cheyenne
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Expert surplus valve buyers serving Cheyenne's energy facilities and Wyoming's capital region industrial operations.
                </p>
              </Link>

              <Link
                to="/casper"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Casper
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Trusted surplus valve buyers in Casper purchasing from oil and gas operations throughout central Wyoming.
                </p>
              </Link>

              <Link
                to="/salt-lake-city"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Salt Lake City
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Professional surplus valve buyers serving Salt Lake City's mining operations and chemical processing facilities in Utah.
                </p>
              </Link>

              <Link
                to="/provo"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Provo
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Experienced surplus valve buyers in Provo serving manufacturing facilities and industrial operations in Utah Valley.
                </p>
              </Link>

              <Link
                to="/denver"
                className="group bg-white hover:bg-teal-50 p-6 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg border border-gray-200"
              >
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-700 transition-colors">
                  Surplus Valve Buyers in Denver
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Leading surplus valve buyers serving Denver's energy sector and Colorado's Front Range industrial facilities.
                </p>
              </Link>
            </div>

            <div className="text-center mt-12">
              <Link
                to="/contact"
                className="inline-block bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap"
              >
                Get Your Free Quote Today
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default WeBuySurplusValvesPage;